export default __webpack_public_path__ + "static/media/1635950212302373.c6bfca28.otf";